import { LOADING_CELLS, keyStatsView } from "../../utils/keyStatsView";
import type { SourceDataFirm } from "../../utils/sourceDataFirm";
import styles from "./KeyStatsBar.module.css";
import { useKeyStats } from "./useSourceData";

type KeyStatsBarProps = {
  firm: SourceDataFirm;
  editionId: string;
  researchBpaId: string;
  /** Requests only while true — the panel passes its open state. */
  enabled: boolean;
};

export function KeyStatsBar({ firm, editionId, researchBpaId, enabled }: KeyStatsBarProps) {
  const view = keyStatsView(useKeyStats({ firm, editionId, researchBpaId, enabled }));

  if (view.kind === "error") {
    return (
      <div role="alert" className={styles.error}>
        {view.message}
      </div>
    );
  }

  const loading = view.kind === "loading";
  const cells = view.kind === "stats" ? view.cells : LOADING_CELLS;
  const note = view.kind === "stats" ? view.note : null;

  return (
    <div className={styles.wrap}>
      {loading && <span role="status" aria-label="Loading key stats" className={styles.srOnly} />}
      <div
        role="group"
        aria-label="Key stats"
        aria-busy={loading ? true : undefined}
        className={styles.stats}
      >
        {cells.map(cell => (
          <div key={cell.caption} className={styles.stat}>
            <span className={styles.value} data-tone={cell.check ? "success" : undefined}>
              {cell.value}
            </span>
            <span className={styles.caption} title={cell.tooltip}>
              {cell.caption}
            </span>
          </div>
        ))}
      </div>
      {note && <p className={styles.note}>{note}</p>}
    </div>
  );
}
